<template>
  <div>
    <v-card max-width="600px">
      <v-img
        class="white--text"
        height="200px"
        src="/static/img/calc.JPG"/>
      <v-card-title primary-title>
        <h1>{{$vuetify.t('$vuetify.calc.title')}}</h1>
      </v-card-title>
      <v-card-text v-html="$vuetify.t('$vuetify.calc.topmsg')">
        To calculate your spring rate, you need to enter some details. The result is a theoretical calculated recommendation, it can vary by your personal preferences and your
        bike.
        If you ride a very heavy bike, like an ebike you should add some additional weight, depending of motor and battery 3-8kg.
      </v-card-text>
      <v-card-text>
        <v-layout class="row">
          <v-img class="icon weight" src="/static/img/calc/weight.png" contain></v-img>
          <v-text-field class="wider" :label="$vuetify.t('$vuetify.calc.riderweight')" v-model="weight" @click:append="weightGrams = !weightGrams" :suffix="weightGrams ? 'kg' : 'lbs'"
                        append-icon="compare_arrows"
                        v-validate="{required:true,regex:/\d+[\\.]?\d*$/}"
                        :error-messages="errors.collect('weight')"
                        :data-vv-as="$vuetify.t('$vuetify.calc.riderweight')"
                        data-vv-name="weight"></v-text-field>
        </v-layout>

        <v-layout class="row" wrap>
          <v-layout>
            <v-img class="icon weight" src="/static/img/calc/shock-stroke.png" contain></v-img>
            <v-text-field :label="$vuetify.t('$vuetify.calc.shockstroke')" v-model="shockStroke" @click:append="shockMetric = !shockMetric" :suffix="shockMetric ? 'mm' : 'inch'" append-icon="compare_arrows"
                          v-validate="{required:true,regex:/\d+[\\.]?\d*$/}"
                          :error-messages="errors.collect('shockStroke')"
                          :data-vv-as="$vuetify.t('$vuetify.calc.shockstroke')"
                          data-vv-name="shockStroke"></v-text-field>
          </v-layout>
          <v-layout>
            <v-img class="icon weight" src="/static/img/calc/wheel-travel.png" contain></v-img>
            <v-text-field :label="$vuetify.t('$vuetify.calc.wheeltravel')" v-model="travel" @click:append="travelMetric = !travelMetric" :suffix="travelMetric ? 'mm' : 'inch'" append-icon="compare_arrows"
                          v-validate="{required:true,regex:/\d+[\\.]?\d*$/}"
                          :error-messages="errors.collect('travel')"
                          :data-vv-as="$vuetify.t('$vuetify.calc.wheeltravel')"
                          :data-vv-name="$vuetify.t('$vuetify.calc.wheeltravel')"></v-text-field>
          </v-layout>
        </v-layout>
        <v-select :label="$vuetify.t('$vuetify.calc.sag.label')" :items="sagOptions" v-model="sag" return-json></v-select>

        <div v-if="result1">
          <h3>{{$vuetify.t('$vuetify.calc.results')}}<</h3>
          <v-layout>
            <v-flex xs6>
              {{$vuetify.t('$vuetify.calc.singlepivot_title')}}<br>
              {{result1}} lbs
            </v-flex>
            <v-flex xs6>
              {{$vuetify.t('$vuetify.calc.vpp_title')}}<br>
              {{result2}} lbs
            </v-flex>
          </v-layout>
        </div>
      </v-card-text>
    </v-card>

    <!--<v-card max-width="600px" class="mt-3">-->
    <!--<v-card-title><h3>Notes</h3></v-card-title>-->
    <!--<v-card-text>-->
    <!---->
    <!--</v-card-text>-->
    <!--</v-card>-->
  </div>
</template>

<script>
  import StringMixinx from '../mixins/StringMixin'
  import VeeValidate from 'vee-validate'
  import {eventBus} from '../main';
  import Vue from 'vue'

  Vue.use(VeeValidate)

  export default {
    mixins: [StringMixinx],
    name: 'SpringCalculator',
    created() {
      eventBus.$emit('title-change', this.$vuetify.t('$vuetify.calc.title'));
    },
    data() {
      return {
        sagOptions: [{text: this.$vuetify.t('$vuetify.calc.sag.plush'), value: 'plush'}, {text: this.$vuetify.t('$vuetify.calc.sag.firm'), value: 'firm'}],
        sag: 'plush',
        weightGrams: true,
        travelMetric: false,
        shockMetric: false,
        weight: '',
        travel: '',
        shockStroke: '',
      }
    },
    computed: {
      result1() {
        return Math.round((this.toGrams(this.weight, this.weightGrams) * (this.sag == 'plush' ? 4.5 : 4.8)) / this.toInch(this.shockStroke, this.shockMetric) *
          (this.toInch(this.travel, this.travelMetric) / this.toInch(this.shockStroke, this.shockMetric)));
      },
      result2() {
        return Math.round((this.toGrams(this.weight, this.weightGrams) * (this.sag == 'plush' ? 4.9 : 5.2)) / this.toInch(this.shockStroke, this.shockMetric) *
          (this.toInch(this.travel, this.travelMetric) / this.toInch(this.shockStroke, this.shockMetric)));
      }
    },
    methods: {
      toInch(value, isMetric) {
        return isMetric ? value / 25.4 : value;
      },
      toGrams(value, isGrams) {
        return isGrams ? value : value / 2.2
      }
    }
  }
</script>

<style scoped>
  .icon {
    height: 30px;
    width: 60px;
    flex-grow: 0;
    align-self: center;
  }

  .row .v-text-field {
    max-width: 150px;
    margin: 0 10px;
  }

  .row .v-text-field.wider {
    max-width: 200px;
  }

  .v-select {
    max-width: 100px;
    margin-left: 70px;
  }
</style>



// WEBPACK FOOTER //
// src/views/SpringCalculator.vue